import styled from "styled-components";
import { Link } from "react-router-dom";
import { mainColor } from "../../styles/global";

export const NavBarWrapper = styled.nav`
  position: sticky;
  z-index: 999;
  top: 0;
  right: 0;
  left: 0;
  padding: 0.5rem 5%;
  width: 100%;
  height: 80px;
  display: flex;
  // background-color: #e5e5e5;
  // background:rgba(0,0,0,1);
  // background-image: url("img/Rectangle 700.svg");
  // background-color: rgba(0,0,0,.9);
`;
export const NavBarContainer = styled.div`
  width: 90%;
  height: 80px;
`;
export const MenuIconBar = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1000;
    transform: translate(-100%, 10%);
    font-size: 3rem;
    cursor: pointer;
    color: black;
  }
`;
export const NavLink = styled(Link)`
  color: #363636;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 10%;
  cursor: pointer;
  white-space: nowrap;
  font-weight:;
  &.active {
    color: ${mainColor};
  }
  &:hover {
    color: #090458;
    transition: all 0.4s ease;
  }
  @media screen and (max-width: 768px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;
    font-size: 1.5rem;
    padding: 0.1rem;
  }
`;
export const NavItem = styled.li`
  border-bottom: 2px solid transparent;
`;
export const NavItemList = styled.ul`
  @media screen and (max-width: 768px) {
    height: 100vh;
    padding-bottom: 50px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const NavLogoLink = styled(Link)`
  width: 10%;
  img {
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width: 768px) {
    width: 30%;
  }
`;
export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
`;
export const NavBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  width: 100%;
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;
export const BtnLink = styled(Link)`
  border-radius: 4px;
  background: ${mainColor};
  padding: 10px 22px;
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  white-space: nowrap;
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
    &:hover {
      transition: all ease-in-out 0.3s;
      transform: translateX(3px);
      cursor: pointer;
      opacity: 0.7;
    }
  }
`;
